import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/payments/_authenticated')({
  beforeLoad: async () => {
    const hasToken = sessionStorage.getItem('token');

    if (!hasToken) {
      throw redirect({
        to: '/404',
      });
    }
  },
});
